<template>
    <div class="customer">
        <div class="hidden-md-and-up phone">
            <p class="title">
                刘燕酿制专属顾问为您服务
            </p>
            <div class="times">
                <div>
                    <img style="width:0.37rem" src="../../static/mobile/kefu.png" alt="">
                    <p>在线专属顾问<br/>为您解答所有疑惑</p>
                    <span>工作时间：9:00-18:00</span>
                </div>
                <div>
                    <img style="width:0.32rem" src="../../static/mobile/dingdan.png" alt="">
                    <p>关于订单或技术问题<br/>一一为您解决</p>
                    <span>工作时间：9:00-18:00</span>
                </div>
            </div>
            <!-- <div class="customerbox" @click="customeClick">
                <img style="width:0.37rem;vertical-align: sub;" src="../../static/mobile/kefu.png" alt="">
                <span>在线客服</span>
            </div> -->
            <div class="customerbox" @click="customeClick">
                <img style="width:0.28rem;vertical-align: sub;" src="../../static/mobile/dianhua2.png" alt="">
                <a class="custphone" href="tel:4000017748">400-001-7748</a>
            </div>
            <div class="btn" @click="btnclick">
                不，谢谢
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewLiuyanShopWebCustomer',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        customeClick(){
            console.log(123)
                window.location.href = 'https://p.qiao.baidu.com/cps3/chatIndex?siteToken=3b2f0a51f179531da12cae6226ebd9ef&speedLogId=16366846030004b99_1636684603000_64117&reqParam=%7B%22from%22%3A0%2C%22sessionid%22%3A%2200dfab70-1d07-423d-8316-daac16a90de5%22%2C%22siteId%22%3A%2214526955%22%2C%22tid%22%3A%22-1%22%2C%22userId%22%3A%2227865118%22%2C%22ttype%22%3A1%2C%22siteConfig%22%3A%7B%22eid%22%3A%2227865118%22%2C%22queuing%22%3A%22%22%2C%22siteToken%22%3A%223b2f0a51f179531da12cae6226ebd9ef%22%2C%22userId%22%3A%2227865118%22%2C%22vstProto%22%3A1%2C%22likeVersion%22%3A%22generic%22%2C%22siteId%22%3A%2214526955%22%2C%22online%22%3A%22true%22%2C%22webRoot%22%3A%22https%3A%2F%2Fp.qiao.baidu.com%2Fcps3%2F%22%2C%22bid%22%3A%22163575421927671431%22%2C%22isSmallFlow%22%3A0%2C%22isPreonline%22%3A0%2C%22invited%22%3A0%7D%2C%22config%22%3A%7B%22themeColor%22%3A%22F84048%22%7D%7D'
        },
        btnclick(){
            this.$router.push({path:'/'})
        }
    },
};
</script>

<style lang="less" scoped>
.phone{
    .title{
        font-size: 0.33rem;
        font-weight: 900;
        color: #00383F;
        padding: 0.64rem 0 0.24rem 0;
    }
    .times{
        margin: 0 0.79rem 0.19rem 0.8rem;
        border: 1px solid #00383F;
        display: flex;
        div{
            width: 50%;
            img{
                padding-top: 0.59rem;
                padding-bottom: 0.32rem;
            }
            p{
                font-size: 0.24rem;
                font-weight: bold;
                margin: 0 auto;
                padding-bottom: 0.1rem;
            }
            span{
                font-size: 0.24rem;
                display: inline-block;
                padding-bottom: 0.38rem;
                font-weight: bold;
            }
         
        }
        div:nth-child(2){
           border-left: 1px solid #00383F;
              p{
            }
        }
    }
    .customerbox{
        height: 0.91rem;
        border: 1px solid #00383F;
        margin: 0 0.79rem 0.19rem 0.8rem;
        line-height: 0.91rem;
        span{
            font-size: 0.36rem;
            font-weight: 900;
            margin-left: 0.1rem;
        }
    .custphone{
        font-size: 0.36rem;
            font-weight: 900;
            margin-left: 0.1rem;
    }
    }
    .btn{
         margin: 0.5rem 0.79rem 3rem 0.8rem;
         height: 0.895rem;
         line-height: 0.9rem;
         background: #00383F;
        border: 1px solid #00383F;
        color: #fff;
        font-size: 0.33rem;
        font-weight: 90
    }
}
</style>


// WEBPACK FOOTER //
// src/view/customer.vue